import React from "react";
import { Link } from "gatsby";
import Container from "../Container";
import ModuleSpacing from "../ModuleSpacing";

import LogoMark from "../../resources/assets/logo-mark.svg";
import Facebook from "../../resources/assets/facebook.svg";
import Instagram from "../../resources/assets/instagram.svg";
import LinkedIn from "../../resources/assets/linkedin.svg";
import Twitter from "../../resources/assets/twitter.svg";
import YouTube from "../../resources/assets/youtube.svg";

import styles from "./Footer.module.css";

const Footer = () => (
	<footer>
		<Container>
			<ModuleSpacing bottom={false}>
				<div className={styles.container}>
					<div className={styles.newsletter}>
						<strong>Sign up for our newsletter</strong>
						<p>Get our newsletter for fresh research and resources delivered to your inbox.</p>
						<iframe src="https://www2.goodwaygroup.com/l/285612/2021-02-26/d55yy9" width="100%" height="296" type="text/html" frameBorder="0" style={{ border: 0 }}></iframe>
					</div>
					<div className={styles.social}>
						<strong>Social</strong>
						<ul>
							<li>
								<a href="https://www.facebook.com/goodwaygroup/" target="_blank" rel="noreferrer"><Facebook /> Facebook</a>
							</li>
							<li>
								<a href="https://www.instagram.com/goodwaygroup/" target="_blank" rel="noreferrer"><Instagram /> Instagram</a>
							</li>
							<li>
								<a href="https://www.linkedin.com/company/goodway-group" target="_blank" rel="noreferrer"><LinkedIn /> LinkedIn</a>
							</li>
							<li>
								<a href="https://twitter.com/goodwaygroup" target="_blank" rel="noreferrer"><Twitter /> Twitter</a>
							</li>
							<li>
								<a href="https://www.youtube.com/channel/UC3dKyD1ZRtthnhnXdCF8ELQ" target="_blank" rel="noreferrer"><YouTube /> YouTube</a>
							</li>
						</ul>
					</div>
					<div className={styles.logoMark}>
						<LogoMark />
					</div>
				</div>
				<div className={`${styles.container} ${styles.bottom}`}>
					&copy; {new Date().getFullYear()}, Goodway Group
					<ul>
						<li><Link to="/privacy-policy">Privacy Policy</Link></li>
						<li><Link to="/terms">Terms &amp; Conditions</Link></li>
						<li><Link to="/do-not-sell-info">Do Not Sell My Information</Link></li>
					</ul>
				</div>
			</ModuleSpacing>
		</Container>
	</footer>
);

export default Footer;